<template>
  <div class="bjy-playback-message-list-wrap">
    <div class="placeholder"></div>

    <!-- <p class="checkbox-wrap">
      <input class="" v-model="onlyShowTeacher" type="checkbox">
      只看老师
    </p> -->
    <a-modal
      centered
      :visible="imgPreviewSrc !== ''"
      @ok="() => (imgPreviewSrc = '')"
      @cancel="() => (imgPreviewSrc = '')"
      width="500"
      :footer="false"
    >
      <a :href="imgPreviewSrc" target="_blank" class="text-center">
        <img :src="imgPreviewSrc" class="large"/>
        <div>点击查看原图</div>
      </a>
    </a-modal>
  </div>
</template>

<script>
import userRoleMap from './common/roleMap'

const config = BJY.config
let messageListInstance = null

export default {
  components: {},
  data() {
    return {
      onlyShowTeacher: false,
      imgPreviewSrc: '',
    }
  },
  watch: {
    onlyShowTeacher(newValue, oldValue) {
      if (newValue) {
        console.log('只看老师')
      } else {
        console.log('取消只看老师')
      }
      messageListInstance.scrollToBottom()
      BJY.playback.setMessageFilter(newValue ? this.isTeacherMessage : null)
    },
  },
  methods: {
    isTeacherMessage(message) {
      if (message.from) {
        var type = message.from.type
        return type === config.ROLE_TYPE_TEACHER || type === config.ROLE_TYPE_ASSISTANT
      }

      if (message.user) {
        var role = message.user.role
        return role === 'teacher' || role === 'assistant'
      }

      return false
    },
  },
  created() {
  },
  mounted() {
    messageListInstance = BJY.MessageList.create({
      element: $('.bjy-playback-message-list-wrap .placeholder'),
      renderEmoji: function (name, url) {
        if (BJY.isAlicloudImage(url)) {
          return (
            '<img ondragstart="return false" src="' +
            (url + '@100w_1e_1l.png') +
            '" srcset="' +
            (url + '@200w_1e_1l.png') +
            ' 2x">'
          )
        }
        return '<img ondragstart="return false" src="' + url + '">'
      },
      renderImage: function (url) {
        if (BJY.isAlicloudImage(url)) {
          return (
            '<img class="message-img" ondragstart="return false" src="' +
            (url + '@100w_1e_1l.png') +
            '" srcset="' +
            (url + '@200w_1e_1l.png') +
            ' 2x">'
          )
        }
        return '<img ondragstart="return false" src="' + url + '">'
      },
      renderUser: function (user, width, height) {
        var imageUrl = ''
        const arr = user.avatar.split('.')
        const fileType = arr[arr.length - 1]
        imageUrl = 'https://static.51lss.com/data/img/defaultStudentPhoto.png?x-image-process=image/resize,w_40,limit_0'
        return {
          id: user.id,
          name: user.name,
          number: user.number,
          // 头像需压缩
          avatar: BJY.compressImage({
            url: imageUrl,
            width: width,
            height: height,
          }),
          avatar2x: BJY.compressImage({
            url: imageUrl,
            width: width * 2,
            height: height * 2,
          }),
          // 根据用户类型，配置角色的英文和本地语言
          role: userRoleMap[user.type].en,
          localRole: userRoleMap[user.type].cn,
        }
      },
      loadDistance: 0,
      messageFilter: function (message) {
        if (message && message.content && message.content.indexOf('videocc') > -1) {
          return false
        } else {
          return true
        }
      },
    })
    const that = this
    messageListInstance.nextTick(function () {
      $(messageListInstance.$el).on('click', '.bjy-content .message-img', function () {
        var src = $(this).attr('src')
        var splitEle = /\?x-oss-process/.test(src) ? '?x-oss-process' : '@'
        var originSrc = src.split(splitEle)[0]
        that.imgPreviewSrc = originSrc
      })
    })
  },
  beforeDestroy() {
    messageListInstance && messageListInstance.destroy()
  },
}
</script>

<style lang="scss">
//@import url(); 引入公共css类
.bjy-playback-message-list-wrap {
  height: 100%;
  width: 100%;
  position: relative;

  .placeholder {
    bottom: 20px;
    height: unset;
  }

  .checkbox-wrap {
    position: absolute;
    bottom: 0;
    right: 5px;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}

.large {
  max-width: 450px;
  height: auto;
  margin-top: 20px;
}
</style>
